

import LinkButton from '@core/components/linkbutton/LinkButton';
import classes from './ResumeAnalyzerBanner.module.scss';


const ResumeAnalyzerBanner = () => {

    return (
        <div className={`${classes['banner']} container my-3`}>
            <div className={`${classes['banner-inner']}`}>
                <div className={classes['banner-text']}>
                    <h5>Get matched to jobs faster</h5>
                    <p>Analyze your resume to uncover skill gaps and boost your chances of landing the right role.</p>
                </div>
                <LinkButton
                    kind='primary-color'
                    to={'/profile/my-resume'}
                >
                    Analyze My Resume
                </LinkButton>
            </div>
        </div>
    );
};

export default ResumeAnalyzerBanner;
